import { Stack } from "@mui/material";
import React from "react";
import { categories } from "../../utils/constants";
import CategoryButton from "./CategoryButton";

const Sidebar = ({ selectedCategory, setSelectedCategory }) => {
  return (
    <Stack
      direction="row"
      sx={{
        overflowY: "auto",
        height: { sx: "auto", md: "95%" },
        flexDirection: { md: "column" },
      }}
    >
      {categories.map((category) => {
        return (
          <CategoryButton
            key={category.name}
            setSelectedCategory={setSelectedCategory}
            selectedCategory={selectedCategory}
            name={category.name}
            icon={category.icon}
          />
        );
      })}
    </Stack>
  );
};

export default Sidebar;
